export const workingTimeDTOFields = {
    teacherId: 'teacherId',
    firstName: 'firstName',
    lastName: 'lastName',
    timeFrom: 'timeFrom',
    timeTo: 'timeTo',
    absent: 'absent',
} as const;
